var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayeredPeaksHaikei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 235,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_1",
    fill: "#ffffff",
    height: 239.00003,
    width: 898.99996,
    y: -0.66668,
    x: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#000000",
    d: "m0,0.33334l129,49l128,6l129,26l128,-59l129,-6l128,-1l129,55l0,169l-129,0l-128,0l-129,0l-128,0l-129,0l-128,0l-129,0l0,-239z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#3b3b3b",
    d: "m0,53.33334l129,56l128,-60l129,5l128,39l129,6l128,-55l129,71l0,124l-129,0l-128,0l-129,0l-128,0l-129,0l-128,0l-129,0l0,-186z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#777777",
    d: "m0,86.33334l129,21l128,-9l129,13l128,27l129,-63l128,12l129,32l0,120l-129,0l-128,0l-129,0l-128,0l-129,0l-128,0l-129,0l0,-153z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#b9b9b9",
    d: "m0,149.33334l129,-24l128,-1l129,45l128,-9l129,-33l128,40l129,-14l0,86l-129,0l-128,0l-129,0l-128,0l-129,0l-128,0l-129,0l0,-90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#ffffff",
    d: "m0,207.33334l129,-39l128,21l129,-27l128,1l129,40l128,-9l129,16l0,29l-129,0l-128,0l-129,0l-128,0l-129,0l-128,0l-129,0l0,-32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredPeaksHaikei);
export default __webpack_public_path__ + "static/media/layered-peaks-haikei.b41554ddc4f29a2a350dc59423820452.svg";
export { ForwardRef as ReactComponent };